<template>
    <div class="columns">
        <div class="column is-12-mobile is-12-desktop is-12-widescreen">
            <div class="level">
                <div class="level-left">
                    <div class="title is-marginless is-paddingless">Onboarding verification
                        <span v-if="is_loading || fetching_data" class="button is-white has-text-right preloader" :class="{'is-loading': (is_loading || fetching_data)}"></span>
                    </div>
                </div>
            </div>
            <div class="columns" v-if="!is_loading">
                <div class="column is-paddingless is-marginless">
                    <search v-on:search="search($event)"
                            placeholder="Search"
                            :addMarginLeft=false
                            class="is-paddingless is-marginless"></search>
                </div>
            </div>
            <p v-if="!is_loading" class="margin-top-30" v-resultsCount="[total_records, all_records]"></p>
            <div class="level" v-if="!is_loading">
                <table class="table is-size-7-touch is-marginless is-fullwidth">
                    <thead>
                    <tr v-if="items.length > 0">
                        <td colspan="8" class="has-text-right padding-bottom-0">
                            <button
                                    @click="removeOnboards()"
                                    :disabled="no_of_items === 0"
                                    type="submit"
                                    :class="[{'is-loading': is_deleting_onboards }]"
                                    class="button is-button-grey is-button-medium">DELETE
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td class="is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey paddingless-td"></td>
                        <td class="pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Date</td>
                        <td class="is-narrow-mobile pad35-desktop is-desktop is-size-7-desktop has-text-weight-bold has-text-grey">Business name</td>
                        <td class="is-hidden-mobile pad90-desktop is-size-7-desktop has-text-weight-bold has-text-grey">User</td>
                        <td class="is-hidden-mobile pad90-desktop is-hidden-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Email address</td>
                        <td class="is-hidden-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Reviews count</td>
                        <td class="is-size-7-mobile is-narrow"></td>
                        <td class="is-size-7-mobile"></td>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-if="(is_loading && items.length === 0) || (!fetching_data && items.length === 0)">
                            <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey " colspan="7">
                                <p class="has-text-centered is-padded-20">No results found</p>
                            </td>
                        </tr>
                        <tr class="margin-bottom-20" v-if="items.length > 0" v-for="(onboard, index) in items">
                            <td class="is-size-7-mobile is-size-7-touch paddingless-td">
                                <label class="label is-size-7 has-text-centered clickable-checkbox">
                                    <input type="checkbox"
                                           ref="deletes"
                                           @change="collateItemsToRemove(onboard, index, $event)">
                                </label>
                            </td>
                            <td class="is-size-7-mobile is-size-7-touch">{{onboard.created_at_date}}</td>
                            <td class="is-narrow-mobile is-desktop">{{onboard.business_name}}</td>
                            <td class="is-hidden-mobile is-desktop">{{onboard.user}}</td>
                            <td class="is-hidden-mobile is-desktop">{{onboard.business_user_email}}</td>
                            <td class="is-hidden-mobile is-desktop">{{onboard.reviews_count}}</td>
                            <td class="is-size-7-mobile is-narrow">
                                <a @click.prevent="removeOnboard(onboard)" href="#" class="has-text-underlined color-2aabe1">Remove
                                    <span :ref="`preloader_${onboard.id}`" class="button is-white has-text-right preloader is-background-f5f5f5"></span>
                                </a>
                            </td>
                            <td class="is-size-7-mobile">
                                <a @click.prevent="checkAndActivateOnboard(onboard, index, $event)" href="#" :ref="`onboard_${index}`" class="button is-button-blue is-hidden-mobile is-button-medium is-pulled-right">ACTIVATE</a>
                                <a @click.prevent="checkAndActivateOnboard(onboard, index, $event)" href="#" :ref="`onboard_${index}`" class="button-mobile is-button-blue is-hidden-tablet circle-border is-hidden-widescreen mobile-anchor-button-tick-padding"><i class="fas fa-check"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="level">
                <paginator :dataSet="dataSet" @changed="getOnboardingRecords" :keyword_string="keyword_string"></paginator>
            </div>
        </div>
    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import Search from './../../components/Search.vue'
  import axios from 'axios'
  import Paginator from './../../components/Paginator.vue'
  import misc from '../../mixins/misc.js'
  import qs from 'qs'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Business Onboarding Verification'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Business Onboarding Verification'
      })
    },
    components: {Search, Paginator},
    mixins: [misc],
    data () {
      return {
        delete_items: {},
        no_of_items: 0,
        is_deleting_onboards: false,
        is_deleting_onboard: false,
        is_loading: true,
        fetching_data: false,
        keyword_search: undefined,
        keyword_string: undefined,
        items: [],
        dataSet: {},
        page: undefined,
        total_records: 0,
        all_records: -1
      }
    },
    created () {
      this.getOnboardingRecords(null)
      window.events.$on('forceActivateOnboard', ({dataForTask}) => {
        this.activateOnboard(dataForTask.onboard, dataForTask.index, dataForTask.event)
      })
    },
    destroyed () {
      window.events.$off('forceActivateOnboard')
    },
    methods: {
      collateItemsToRemove (onboard, index, event) {
        let checked = JSON.parse(event.target.checked)
        if (checked) {
          this.delete_items[index] = onboard.id
        } else {
          delete this.delete_items[index]
        }

        this.no_of_items = Object.keys(this.delete_items).length
      },
      removeOnboard (onboard) {
        this.$refs[`preloader_${onboard.id}`][0].classList.add('is-loading')
        axios.get(`/onboarding/decline/${onboard.id}`)
            .then(() => {
              flash(`${onboard.business_name} rejected successfully.`)
              if (this.items.length === 0 && this.page > 1) {
                this.getOnboardingRecords(this.page - 1)
              } else {
                this.getOnboardingRecords(this.page)
              }
              this.$refs[`preloader_${onboard.id}`][0].classList.remove('is-loading')
            })
            .catch(() => {
              this.$refs[`preloader_${onboard.id}`][0].classList.remove('is-loading')
              flash(`Failed to reject ${onboard.business_name}`, 'is-danger')
            })
      },
      /**
       * Makes a call to api with a list of onboard records to decline
       * @returns {void}
       */
      removeOnboards () {
        let postData = {onboards: this.delete_items}
        this.is_deleting_onboards = true
        axios.post('/onboarding/decline', postData)
            .then(() => {
              this.is_deleting_onboards = false
              let itemKeys = Object.keys(this.delete_items)
              itemKeys.forEach((item, key) => {
                this.items.splice(key, 1)
              })
              this.delete_items = {}
              this.no_of_items = 0

              this.$refs.deletes.forEach((item) => {
                item.checked = false
              })
              flash('Onboard records rejected successfully.')
              if (this.items.length === 0 && this.page > 1) {
                this.getOnboardingRecords(this.page - 1)
              } else {
                this.getOnboardingRecords(this.page)
              }
            })
            .catch(() => {
              this.is_deleting_onboards = false
              flash(`Failed to reject onboarding records`, 'is-danger')
            })
      },
      /**
       * Makes a call to api to activate onboarding record.
       * @param {object} onboard onboarding record
       * @param {integer} index index of onboard in items collection
       * @param {event} event record to activate
       * @returns {void}
       */
      checkAndActivateOnboard (onboard, index, event) {
        axios.get(`business/${onboard.business_slug}/exist-as-deleted`)
          .then(({data}) => {
            if (data.exist) { // Deleted business with same slug exist in database
              modal({
                title: 'Confirm activation',
                body: `${data.data.name} was previously deleted on ${data.data.date} at ${data.data.time}. The reason given: <strong>${data.data.reason}</strong><br /><br />Do you want to re-activate this business?`,
                btn_action_title: 'ACTIVATE',
                show_btns: true,
                task: 'forceActivateOnboard',
                dataForTask: {
                  onboard,
                  index,
                  event
                }
              })
            } else {
              this.activateOnboard(onboard, index, event)
            }
          })
          .catch(error => {
            this.displayErrMsg(error, 'Failed to activate onboarding business from Business Verification page', `Failed to activate business`)
          })
      },
      /**
       * Makes a call to api to activate onboarding record.
       * @param {object} onboard onboarding record
       * @param {integer} index index of onboard in items collection
       * @param {event} event record to activate
       * @returns {void}
       */
      activateOnboard (onboard, index, event) {
        let element = event.target
        if (element.parentElement.localName === 'a') {
          element = event.target.parentElement
        }
        element.classList.add('is-loading')
        axios.get(`/onboarding/free/activate/${onboard.id}`)
            .then(() => {
              this.$gtm.trackEvent({
                event: 'AccountActivatedByAdmin',
                plan: 'Free'
              })
              element.classList.remove('is-loading')
              this.items.splice(index, 1)
              if (this.items.length === 0 && this.page > 1) {
                this.getOnboardingRecords(this.page - 1)
              } else {
                this.getOnboardingRecords(this.page)
              }
              flash(`${onboard.business_name} activated.`)

              this.recacheOnBizModified([onboard.business_slug], [onboard.industrySlug])
            })
            .catch(() => {
              element.classList.remove('is-loading')
              flash(`Failed to activate ${onboard.business_name}.`, 'is-danger')
        })
      },
      /**
       * Search keyword/term to search for
       * @param {string} search search term/keyword
       * @returns {void}
       */
      search (search) {
        this.keyword_search = qs.stringify({keyword: search})
        this.keyword_string = search
        this.getOnboardingRecords(1)
      },
      /**
       * Make request to api to get onboarding records
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getOnboardingRecords (page) {
        this.page = page
        this.fetching_data = true
        axios.get(this.url(page, this.keyword_search))
            .then((response) => {
              this.refresh(response)
              this.is_loading = false
              this.fetching_data = false
            })
            .catch(() => {
              flash('You are not authorized to view this resource.', 'is-danger')
              this.is_loading = false
              this.fetching_data = false
            })
      },
      /**
       * Compute URI to make call to api with.
       * @param {string} page starting page to request
       * @param {string} keyword search keyword
       * @return {string}
       */
      url (page, keyword) {
        if (!page) {
          let query = location.search.match(/page=(\d+)/)

          page = query ? query[1] : 1
        }

        if (keyword !== undefined && this.keyword_string !== 0) {
          page += `&${keyword}`
        }

        return `/onboarding/free?page=${page}`
      }
    }
  }
</script>

<style scoped>
    .table td, .table th {
        border: none;
    }

    .table > tbody > tr {
        background-color: #f5f5f5 !important;
        margin-bottom: 10px;
    }

    .table > tbody > td {
        margin-bottom: 20px;
    }
    .table > tbody > tr > td:first-child {
        min-width: 40px
    }
    .paddingless-td {
        padding: 0px !important;
    }
    .clickable-checkbox {
        display: inline-block;
        padding: 15px !important;
        cursor: pointer;
        -webkit-user-select: none; /* webkit (safari, chrome) browsers */
        -moz-user-select: none; /* mozilla browsers */
        -khtml-user-select: none; /* webkit (konqueror) browsers */
        -ms-user-select: none; /* IE10+ */
    }
</style>



// WEBPACK FOOTER //
// src/pages/admin/BusinessOnboardVerification.vue